<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="criterePondere.critere" 
 
[label]="step9.getcritere"
[type]="'text'" [rule]="'minSize_3|maxSize_1000'"
[errorMessage]="{'pattern' : 'ctr_29'}"
[name]="getUid()+'_SepAtt_critere'">
</app-form-input>

 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="criterePondere.criterePCT" 
 
[label]="step9.getcriterepct"
[type]="'number'" [rule]="'minSize_1|maxSize_99'"
[name]="getUid()+'_SepAtt_criterePCT'">
</app-form-input>


